import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LoginApi, RegisterApi, getUserApi, postuserApi, changePasswordApi, getUserbyId, CPRegisterApi, requestOtpByEmail, updateUserData, verifyOtpByEmail, resendOtpByEmail, resetOtpByEmail, deleteAccountApi, changeEmailApi } from '../services/Apis';
import { setauth_status, setauth_token, setIsAdmin } from '../slices/globalslice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';
import { clearAuthToken, getAuthToken, persistAuthToken } from '../utils/authStorage';
import { useEffect } from "react";
import Cookies from 'universal-cookie';


export default function useAuth() {

  const initial_page = useSelector(state => state.globalslice.initial_page);
  const sorting_data = useSelector(state => state.globalslice.sorting_data);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient();
  const postUser = useMutation({
    mutationFn: (formData) => {
      if (formData.id) {

        return updateUserData(formData);// if id exists — update
      } else {
        return postuserApi(formData);    // else — create
      }
    },
    onSuccess: (data) => {
      toast.success('User Updated Successfully', 200)
      queryClient.getQueryCache().findAll().forEach((query) => {
        if (query.queryKey[0] === 'user') {
          queryClient.removeQueries({ queryKey: query.queryKey });
        }
      });
      queryClient.invalidateQueries({ queryKey: ['userById', { id: data.data.toString() }] });
      navigate('/admin/user')
    },
    onError: (error) => {
      console.error('customer failed', error);
    },
  });

  const authLogin = useMutation({
    mutationFn: LoginApi,
    onSuccess: (data) => {
      // dispatch(setauth_status(true))
//       // dispatch(setauth_token(data.data.token))
//       // cookies.set('token', data.data.token, { path: '/' });
//       // const decoded = jwtDecode(data.data.token);
//       // queryClient.invalidateQueries({ queryKey: ['menu-access'] });
//       // const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
      const token = data.data.token;
      persistAuthToken(token);
       localStorage.removeItem('LOGGED_OUT');
      // Send token to React Native WebView if present
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({ type: 'SET_TOKEN', token })
      );

 const decoded = jwtDecode(token);
      const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');

      // Update Redux state
      dispatch(setauth_status(true));
      dispatch(setauth_token(token));
      dispatch(setIsAdmin(isUserAdmin));

      // Invalidate menu-access queries
      queryClient.invalidateQueries({ queryKey: ['menu-access'] });

      // Navigate based on user type
      if (data.data.user_type === "agent") {
        navigate('/crm/leadsList');
      } else if (decoded.type === 'customer') {
        navigate(`/admin/customer/customerpay/${decoded.id}`);

      }else {
        navigate('/dashboard');
      }

    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });

  const authRegister = useMutation({
    mutationFn: CPRegisterApi,
    onError: (error) => {
      console.error('Register failed', error);
    },
  });
     
  // Check token on app load
  useEffect(() => {
    if (localStorage.getItem('LOGGED_OUT') === 'true') {
      dispatch(setauth_status(false));
      dispatch(setauth_token(''));
      dispatch(setIsAdmin(false));
      // navigate('/', { replace: true }); // ✅ FIX: prevent blank screen
      const publicPaths = ['/', '/register', '/forgot-password', '/verify-otp', '/reset-password', '/resend-otp', '/otp-success'];
      if (!publicPaths.includes(location.pathname)) {
        navigate('/', { replace: true });
      }
      return;
    }

    const token = getAuthToken();
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');

    window.ReactNativeWebView?.postMessage(
        JSON.stringify({ type: 'SET_TOKEN', token })
      );



      dispatch(setauth_status(true));
      dispatch(setauth_token(token));
      dispatch(setIsAdmin(isUserAdmin));

      queryClient.invalidateQueries({ queryKey: ['menu-access'] });

    } catch (error) {
      clearAuthToken();
      dispatch(setauth_status(false));
      dispatch(setauth_token(''));
      dispatch(setIsAdmin(false));
    }
  }, [dispatch, location.pathname, navigate]);


  const logout = () => {

    const cookies = new Cookies(); 

    cookies.remove('token', { path: '/' });
    localStorage.setItem('LOGGED_OUT', 'true');
    clearAuthToken();

    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'SET_TOKEN', token: '' }));
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'LOGOUT', token: '', at: Date.now() }));


    localStorage.clear();
    sessionStorage.clear();

    localStorage.setItem('LOGGED_OUT', 'true');

    // Update Redux state
    dispatch(setauth_status(false));
    dispatch(setauth_token(''));
    dispatch(setIsAdmin(false));
    queryClient.removeQueries();
    queryClient.clear();
    navigate('/', { replace: true });
  };


  const getUser = (perPage, agency_id = 0) => {
    return useQuery({
      queryKey: ['user', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date_created', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, "agency_id": agency_id }],
      queryFn: () => getUserApi({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date_created', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, "agency_id": agency_id }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }

  // const changePassword = (setErrors) => {
  //   return useMutation({
  //     mutationFn: changePasswordApi,
  //     onSuccess: () => {
  //       dispatch(setopen_modal(false))
  //     },
  //     onError: (error) => {
  //       setErrors({ 'old_password': error.response?.data?.message })
  //     },
  //   });
  // }
    const changePassword = (setErrors) => {
  return useMutation({
    mutationFn: changePasswordApi,

    onSuccess: (res) => {
      // ✅ 200 → SUCCESS
      // import('react-toastify').then(({ toast }) => {
        toast("Password changed successfully");
      // });
    },

    onError: (error) => {
      // ❌ 401 → WRONG PASSWORD
      if (error?.response?.status === 401) {
        setErrors({
          old_password: error.response?.data?.message || "Old password incorrect"
        });
      } else {
        setErrors({
          old_password: "Something went wrong"
        });
      }
    },
  });
};

  const verifyOtp = useMutation({
    mutationFn: verifyOtpByEmail,
    onSuccess: (data) => {
      navigate('/dashboard');
    },
    onError: (error) => {
      console.error("Error response data:", error.response?.data);
    }
  });

  const getUserDataById = (id) => {
    return useQuery({
      queryKey: ['userById', { 'id': id }],
      queryFn: () => getUserbyId(id),
      enabled: !!id,   // <--- only run if id (slug) exists
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }


  const loginWithOtp = useMutation({
    mutationFn: requestOtpByEmail,
    onSuccess: (data) => {
      if (data.data.uid_hash) {
        localStorage.setItem('uid_hash', data?.data?.uid_hash);
      }
      navigate('/verify-otp');
    },
    onError: (error) => {
      console.error("OTP request failed:", error);
    }
  });
  const resetOtp = useMutation({
    mutationFn: resetOtpByEmail,
    onSuccess: (data) => {
      navigate('/');
    },
    onError: (error) => {
      console.error('Password reset failed', error);
    },
  });

  const ResendOtp = useMutation({
    mutationFn: resendOtpByEmail,
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error('Email reset updated', error)
    }
  })

    const deleteAccount = useMutation({
    mutationFn: deleteAccountApi, 
    onSuccess: () => {
      logout();
      toast.success("Account deleted successfully");
    },

    onError: (error) => {
      console.error("Delete account failed", error);
      toast.error("Failed to delete account");
    },
  });


  const changeEmail = () => {
  return useMutation({
    mutationFn: (formData) => {
        return changeEmailApi(formData);    
      
    },
    onSuccess: (res) => {
      // ✅ 200 → SUCCESS
      // import('react-toastify').then(({ toast }) => {
        toast("Email changed successfully");
      // });
    },

    onError: (error) => {
      // // ❌ 401 → WRONG PASSWORD
      // if (error?.response?.status === 401) {
      //   setErrors({
      //     old_email: error.response?.data?.message || "Old Email incorrect"
      //   });
      // } else {
      //   setErrors({
      //     old_email: "Something went wrong"
      //   });
      // }
       console.error("Delete account failed", error);
      toast.error("Failed to Change email. Please logout and login again");
    },
  });
};

  return {
    authLogin: authLogin,
    authRegister: authRegister,
    logout: logout,
    getUser: getUser,
    changePassword: changePassword,
    postUser: postUser,
    ResendOtp: ResendOtp,
    resetOtp: resetOtp,
    loginWithOtp: loginWithOtp,
    verifyOtp: verifyOtp,
    getUserDataById: getUserDataById,
    deleteAccount : deleteAccount,
    changeEmail : changeEmail
  };
};


//   const authLogin = useMutation({
//     mutationFn: LoginApi,
//     onSuccess: (data) => {
//       // dispatch(setauth_status(true))
//       // dispatch(setauth_token(data.data.token))
//       // cookies.set('token', data.data.token, { path: '/' });
//       // const decoded = jwtDecode(data.data.token);
//       // queryClient.invalidateQueries({ queryKey: ['menu-access'] });
//       // const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');

//       const token = data.data.token;
//       // Persist token using the same utility used by route guards and axios.
//       persistAuthToken(token);
//       localStorage.removeItem('LOGGED_OUT');
//       // Send token to React Native WebView if present
//       window.ReactNativeWebView?.postMessage(
//         JSON.stringify({ type: 'SET_TOKEN', token })
//       );

//       // Decode token to check admin
//       const decoded = jwtDecode(token);
//       const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');
//       // dispatch(setIsAdmin(isUserAdmin))

//       // Update Redux state
//       dispatch(setauth_status(true));
//       dispatch(setauth_token(token));
//       dispatch(setIsAdmin(isUserAdmin));

//       // Invalidate menu-access queries
//       queryClient.invalidateQueries({ queryKey: ['menu-access'] });

//       // Navigate based on user type
//       if (data.data.user_type === "agent") {
//         navigate('/crm/leadsList');
//       } else {
//         navigate('/dashboard');
//       }

//     },
//     onError: (error) => {
//       console.error('Login failed', error);
//     },
//   });

//   // Check token on app load
//   useEffect(() => {
//     const token = getAuthToken();
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');

//         dispatch(setauth_status(true));
//         dispatch(setauth_token(token));
//         dispatch(setIsAdmin(isUserAdmin));

//         // navigate('/dashboard');
//       } catch (error) {
//         clearAuthToken();
//         dispatch(setauth_status(false));
//         dispatch(setauth_token(''));
//         dispatch(setIsAdmin(false));
//       }
//     }
//   }, [dispatch]);

//   //   useEffect(() => {

//   //   const token = getAuthToken();

//   //   if (!token) return;

//   //   try {

//   //     const decoded = jwtDecode(token);

//   //     const isUserAdmin = decoded?.group?.some(group => group.slug === 'admin');

//   //     dispatch(setauth_status(true));
//   //     dispatch(setauth_token(token));
//   //     dispatch(setIsAdmin(isUserAdmin));

//   //   } catch (error) {

//   //     clearAuthToken();

//   //     dispatch(setauth_status(false));
//   //     dispatch(setauth_token(''));
//   //     dispatch(setIsAdmin(false));

//   //   }

//   // }, [dispatch]);

//   const logout = () => {
//     // cookies.remove('token', { path: '/' });
//     // dispatch(setauth_status(false))
//     // dispatch(setauth_token(''))
//     // navigate('/')

//     // Clear auth token from all known browser storage locations/variants.
//     clearAuthToken();

//     localStorage.clear();
//     sessionStorage.clear();

//     // 🔥 ADD THIS (CRITICAL)
//     localStorage.setItem('LOGGED_OUT', 'true');

//     // Notify React Native WebView
//     window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'LOGOUT', at: Date.now() }));


//     // Update Redux state
//     dispatch(setauth_status(false));
//     dispatch(setauth_token(''));
//     dispatch(setIsAdmin(false));
//     queryClient.clear();
//     navigate('/', { replace: true });
//   };

//   //   const logout = () => {

//   //   // Clear token storage
//   //   clearAuthToken();
//   //   localStorage.removeItem('token');
//   //   sessionStorage.clear();

//   //   // Notify React Native WebView
//   //   window.ReactNativeWebView?.postMessage(
//   //     JSON.stringify({ type: 'LOGOUT', at: Date.now() })
//   //   );

//   //   // Reset redux
//   //   dispatch(setauth_status(false));
//   //   dispatch(setauth_token(''));
//   //   dispatch(setIsAdmin(false));

//   //   // Clear react-query cache
//   //   queryClient.clear();

//   //   // Redirect to login
//   //   navigate('/', { replace: true });
//   // };


//   const getUser = (perPage, agency_id = 0) => {
//     return useQuery({
//       queryKey: ['user', { page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date_created', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, "agency_id": agency_id }],
//       queryFn: () => getUserApi({ page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'date_created', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, "agency_id": agency_id }),
//       cacheTime: Infinity,
//       refetchOnMount: false,
//       staleTime: Infinity,
//     });
//   }

//   const changePassword = (setErrors) => {
//     return useMutation({
//       mutationFn: changePasswordApi,
//       onSuccess: () => {
//         dispatch(setopen_modal(false))
//       },
//       onError: (error) => {
//         setErrors({ 'old_password': error.response?.data?.message })
//       },
//     });
//   }
//   const verifyOtp = useMutation({
//     mutationFn: verifyOtpByEmail,
//     onSuccess: (data) => {
//       navigate('/dashboard');
//     },
//     onError: (error) => {
//       console.error("Error response data:", error.response?.data);
//     }
//   });

//   const getUserDataById = (id) => {
//     return useQuery({
//       queryKey: ['userById', { 'id': id }],
//       queryFn: () => getUserbyId(id),
//       enabled: !!id,   // <--- only run if id (slug) exists
//       cacheTime: Infinity,
//       refetchOnMount: false,
//       staleTime: Infinity,
//     });
//   }


//   const loginWithOtp = useMutation({
//     mutationFn: requestOtpByEmail,
//     onSuccess: (data) => {
//       if (data.data.uid_hash) {
//         localStorage.setItem('uid_hash', data?.data?.uid_hash);
//       }
//       navigate('/verify-otp');
//     },
//     onError: (error) => {
//       console.error("OTP request failed:", error);
//     }
//   });
//   const resetOtp = useMutation({
//     mutationFn: resetOtpByEmail,
//     onSuccess: (data) => {
//       navigate('/');
//     },
//     onError: (error) => {
//       console.error('Password reset failed', error);
//     },
//   });

//   const ResendOtp = useMutation({
//     mutationFn: resendOtpByEmail,
//     onSuccess: (data) => {
//     },
//     onError: (error) => {
//       console.error('Email reset updated', error)
//     }
//   })


//   return {
//     authLogin: authLogin,
//     logout: logout,
//     getUser: getUser,
//     changePassword: changePassword,
//     postUser: postUser,
//     ResendOtp: ResendOtp,
//     resetOtp: resetOtp,
//     loginWithOtp: loginWithOtp,
//     verifyOtp: verifyOtp,
//     getUserDataById: getUserDataById,
//   };
// };
